import { OfflineBanner as SharedOfflineBanner } from "@jkast90/kast-common/offline";
import { useAuth } from "../../hooks/useAuth";
import { useOffline } from "../../hooks/useOffline";
import { offlineBannerText } from "../../utils/connectivity";
import styles from "./OfflineBanner.module.css";

/**
 * While the app is offline (the browser says so, or the API keeps failing),
 * a thin strip under the nav bar: "Offline — showing saved data from
 * <time>". It sits in the page flow, so it never covers the page, and the
 * nav bar's own banner (a refused write, a 503) still shows over it. Only
 * for a signed-in user, whose saved data it describes.
 *
 * The strip, its icon and its always-mounted status region are
 * kast-common's; "offline" here is the app's own read-only mode (the
 * CacheManager: the browser offline or the API failing) and the text is the
 * saved-data message.
 */
export default function OfflineBanner() {
  const { isAuthenticated: signedIn } = useAuth();
  const { isReadOnly, browserOffline, savedAt } = useOffline();
  return (
    <SharedOfflineBanner
      offline={signedIn && isReadOnly}
      className={styles.offlineBanner}
    >
      <span data-testid="offline-banner">
        <span>{offlineBannerText(savedAt, browserOffline)}</span>
        <span className={styles.detail}>
          Editing is off until you're back online.
        </span>
      </span>
    </SharedOfflineBanner>
  );
}
